
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/company-info",
      function () {
        return require("private-next-pages/locale/company-info.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/company-info"])
      });
    }
  